import * as React from 'react';
import ReactSelect, * as ReactSelectModule from 'react-select';
import 'react-select/dist/react-select.css';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IMultiSelectInputInterface {
  options?: ReactSelectModule.Options;
  selectedOptions?: ReactSelectModule.Options;
  addItems(items: ReactSelectModule.Option[]): void;
}

const StyledReactSelect = styled(ReactSelect)`
  .Select-value {
    display: none !important;
  }
`;

const SelectedValues = styled.div`
  font-size: 14px;
  padding: 0.5em;
`;

const RemoveSelection = styled.span`
  padding-right: 10px;
  cursor: pointer;
`;

export class MultiSelectInput extends React.Component<IMultiSelectInputInterface, any> {
  public handleChange = (selectedOptions: ReactSelectModule.Option[]) => {
    this.props.addItems(selectedOptions);
  };

  public render() {
    const { selectedOptions = [], options } = this.props;
    return (
      <div>
        <StyledReactSelect
          options={options}
          value={selectedOptions}
          onChange={this.handleChange}
          multi={true}
          style={{ borderRadius: 0 }}
        />
        {selectedOptions.map(selectedValue => (
          <SelectedValues key={selectedValue.label}>
            <RemoveSelection
              title="Remove filter"
              onClick={() =>
                this.props.addItems(
                  selectedOptions.filter(val => val.value !== selectedValue.value)
                )
              }
            >
              <FontAwesomeIcon icon="times" />
            </RemoveSelection>
            {selectedValue.label}
          </SelectedValues>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MultiSelectInput/MultiSelectInput.tsx